import { MoveUnavailableReasonI } from "shared/lib/interfaces/meeting-acceptance";

// Distinct from CONFIRM_CANCEL_MEETING_MODAL_ID in the status section: both
// confirmations sit on the same drawer and a shared id would open both.
export const BMCE_CANCEL_MEETING_MODAL_ID =
  "calendar-event-cancel-meeting-modal";

const MODIFY_INSTEAD = "Rescheduling books a new meeting instead.";

// GLE-8249: shown when the card drops into the Modify-meeting flow because
// the backend cannot move the detected event in place.
export const MOVE_UNAVAILABLE_REASON_MESSAGES: Record<
  MoveUnavailableReasonI,
  string
> = {
  no_calendar_connection: `The AE's calendar is not connected, so the event cannot be moved from Glencoco. ${MODIFY_INSTEAD}`,
  no_write_scope: `The AE's calendar connection has no permission to edit events. ${MODIFY_INSTEAD}`,
  not_detected: `No calendar event was detected for this meeting. ${MODIFY_INSTEAD}`,
  meeting_cancelled: `This meeting was canceled on the calendar. ${MODIFY_INSTEAD}`,
};

export const MOVE_UNAVAILABLE_DEFAULT_MESSAGE = `This calendar event cannot be moved from Glencoco. ${MODIFY_INSTEAD}`;

// The backend allows the move, but the card cannot tell which lead holds the
// meeting, and the move endpoint is addressed to that lead.
export const MOVE_MISSING_CONTACT_MESSAGE = `The lead who holds this meeting could not be identified, so the event cannot be moved from Glencoco. ${MODIFY_INSTEAD}`;

export const getMoveUnavailableMessage = (
  reason: MoveUnavailableReasonI | undefined
): string => {
  if (reason && reason in MOVE_UNAVAILABLE_REASON_MESSAGES) {
    return MOVE_UNAVAILABLE_REASON_MESSAGES[reason];
  }

  return MOVE_UNAVAILABLE_DEFAULT_MESSAGE;
};
